export const staging = {
  production: true, // Toggle me to turn on/off logRocket on staging
  name: "staging",
  useEmulators: false,
  commit: "stagingcommit",
  firebase: {
    apiKey: 'AIzaSyCYBtdiohWAshYczDL_cwt60O88lW2Hl9E',
    authDomain: 'segui-staging.firebaseapp.com',
    databaseURL: 'https://segui-staging.firebaseio.com',
    projectId: 'segui-staging',
    storageBucket: 'segui-staging.appspot.com',
    messagingSenderId: '778797287828',
    appId: '1:778797287828:web:e4bb6494dd440b97566781',
    measurementId: 'G-ZBQZ1G03L0',
  },
  urls: {
    segue: "https://segue-staging.firebaseapp.com",
    segui: "https://segui-staging.firebaseapp.com",
    xview: "https://xview-staging.firebaseapp.com",
    console: "https://innerconsole-staging.firebaseapp.com",
    meshBaseUrl: 'https://storage.googleapis.com/3d-segui-staging/models',
  }
};
